import React from "react";

interface ListProps extends React.HTMLAttributes<HTMLUListElement> {
  children: React.ReactNode;
}

export const List: React.FC<ListProps> = ({
  children,
  className = "",
  ...props
}) => {
  return (
    <ul className={`min-w-[240px] ${className}`} {...props}>
      {children}
    </ul>
  );
};

interface ListItemProps extends React.HTMLAttributes<HTMLLIElement> {
  children: React.ReactNode;
  selected?: boolean;
}

export const ListItem: React.FC<ListItemProps> = ({
  children,
  className = "",
  selected = false,
  ...props
}) => {
  const selectedClass = selected
    ? "bg-blue-50 text-blue-900"
    : "hover:bg-blue-gray-50 hover:bg-opacity-80 focus:bg-blue-gray-50 focus:bg-opacity-80 active:bg-blue-gray-50 active:bg-opacity-80";

  return (
    <li
      className={`flex items-center w-full p-3 leading-tight transition-all rounded-lg outline-none text-start hover:bg-blue-gray-50 hover:bg-opacity-80 hover:text-blue-gray-900 focus:bg-blue-gray-50 focus:bg-opacity-80 focus:text-blue-gray-900 active:bg-blue-gray-50 active:bg-opacity-80 active:text-blue-gray-900 ${selectedClass} ${className}`}
      {...props}
    >
      {children}
    </li>
  );
};

interface ListItemPrefixProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const ListItemPrefix: React.FC<ListItemPrefixProps> = ({
  children,
  className = "",
  ...props
}) => {
  return (
    <div className={`grid mr-4 place-items-center ${className}`} {...props}>
      {children}
    </div>
  );
};

interface ListItemSuffixProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const ListItemSuffix: React.FC<ListItemSuffixProps> = ({
  children,
  className = "",
  ...props
}) => {
  return (
    <div className={`grid ml-auto place-items-center justify-self-end ${className}`} {...props}>
      {children}
    </div>
  );
};